export const insuranceData = [
  {
    iconPath: "/icons/insurances/4.svg",
    title: "אבדן או גניבה",
    text: "במקרה של אובדן מוחלט או גניבה של רכב שגילו מעל 12 חודשים ועד 36 חודשים, יינתן פיצוי מיוחד נוסף בעת רכישת רכב חדש מהיבואנית דלק מוטורס.",
  },
  {
    iconPath: "/icons/insurances/3.svg",
    title: "כיסוי רכב",
    text: "כיסוי של ״חדש תמורת ישן״ לרכב שגילו עד 12 חודשים מיום עלייתו לכביש- במקרה של אובדן מוחלט או גניבה, בעת רכישת רכב חדש מהיבואנית דלק מוטורס תספק דלק מוטורס רכב חדש, עד לשווי כחדש של הרכב המבוטח ללא הפחתות.",
  },

  {
    iconPath: "/icons/insurances/2.svg",
    title: "שימוש חלפים",
    text: "שימוש בחלפים מקוריים חדשים של מאזדה לרכב שגילו עד 24 חודשים במרכזי השירות המורשים הנכללים בהסדר בלבד.",
  },

  {
    iconPath: "/icons/insurances/6.svg",
    title: "השתתפות עצמית",
    text: "השתתפות עצמית מוקטנת בתיקון במרכזי השירות המורשים מטעם דלק מוטורס הנכללים בהסדר.",
  },

  {
    iconPath: "/icons/insurances/8.svg",
    title: "כיסוי לצד שלישי",
    text: "כיסוי לצד שלישי בגבול אחריות מוגדל של 1,000,000 ₪",
  },

  {
    iconPath: "/icons/insurances/1.svg",
    title: "תיקון המכונית",
    text: "תיקון המכונית במרכזי השירות המורשים מטעם דלק מוטורס הנכללים בהסדר.",
  },

  {
    iconPath: "/icons/insurances/7.svg",
    title: "שירותים",
    text: "חבילת שירותים לרכב לרבות רכב חלופי, שירותי דלק ועוד.",
  },

  {
    iconPath: "/icons/insurances/5.svg",
    title: "נזק",
    text: "נזק של מעל 50% ייחשב לנזק מוחלט",
  },

  {
    iconPath: "/icons/insurances/9.svg",
    title: "הרחבות",
    text: "הרחבות וכיסויים נוספים.",
  },
]
